const config = __buildConfig__ || {}

// set the storage based on the specified identifier
// local -> localStorage
// session -> sessionStorage
if (config.storage === 'local') {
    config.storage = localStorage
} else if (config.storage === 'session') {
    config.storage = sessionStorage
} else {
    config.storage = null
}

export { config }
